module.exports = __webpack_public_path__ + "static/media/logo-urbano-blanc.b0220e46.svg";